module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "elevation-1"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('v-card-title', {
    staticClass: "pa-2 pl-4 font-size-16"
  }, [_c('span', {
    staticClass: "font-weight-700"
  }, [_vm._v("Series en")]), _c('span', {
    staticClass: "font-weight-700 primary--text"
  }, [_vm._v("  recall ")]), _c('span', {
    staticClass: "font-weight-700"
  }, [_vm._v(_vm._s(_vm.tipo && _vm.tipo.toLowerCase()))])]), _c('v-card-subtitle', {
    staticClass: "pb-3 font-size-12 grey--text"
  }, [_vm._v("Listado  de tickets que  ingresar con la misma serie")])], 1), _c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "color": "info",
      "small": "small"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.pieChart.fetchTicketsEnRecall()
      }
    }
  }, [_c('v-icon', [_vm._v("sync")]), _vm._v("Actualizar")], 1)], 1), _c('v-divider'), (_vm.count) ? _c('div', {
    staticClass: "d-flex mx-1"
  }, [_c('div', {
    staticClass: "flex-1 ma-2"
  }, [_c('v-card', {
    staticClass: "pa-2 text-xs-center elevation-1",
    attrs: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "d-flex ai-center jc-center fd-column"
  }, [_c('div', {
    staticClass: "display-1 font-weight-700"
  }, [_vm._v(_vm._s(_vm.cantidadTicketsEnRecall))]), _c('span', {
    staticClass: "font-size-12"
  }, [_vm._v("Total de tickets")])])])], 1)]) : _vm._e(), _c('div', {
    staticClass: "d-flex mx-4"
  }, [_c('v-switch', {
    attrs: {
      "dense": "dense",
      "label": "Incluir busqueda en tickets cerrados"
    },
    on: {
      "change": function($event) {
        return _vm.reRenderChart()
      }
    },
    model: {
      value: (_vm.incluirCerrados),
      callback: function($$v) {
        _vm.incluirCerrados = $$v
      },
      expression: "incluirCerrados"
    }
  })], 1), (_vm.renderChart) ? _c('pie-chart', {
    ref: "pieChart",
    attrs: {
      "tipo": _vm.tipo,
      "incluir-cerrados": _vm.incluirCerrados
    },
    on: {
      "count": _vm.obtenerCantidad,
      "click": _vm.obtenerSeleccionado
    }
  }) : _vm._e(), _c('v-expand-transition', [(_vm.reveal) ? _c('v-card', {
    staticClass: "transition-fast-in-fast-out v-card--reveal elevation-0",
    attrs: {
      "height": "100%",
      "loading": _vm.isLoading
    }
  }, [_c('div', {
    staticClass: "d-flex fd-column"
  }, [_c('v-card-title', {
    staticClass: "pa-2 pl-4 font-size-16"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "fab": "fab",
      "x-small": "x-small"
    },
    on: {
      "click": function($event) {
        _vm.reveal = false
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back")])], 1), _c('span', {
    staticClass: "font-weight-700 ml-3"
  }, [_vm._v("Tickets con la serie")]), _c('span', {
    staticClass: "font-weight-700 primary--text"
  }, [_vm._v("  " + _vm._s(_vm.serieRecall) + " ")])], 1)], 1), _c('v-card', {
    staticClass: "elevation-0 overflow-y-auto",
    attrs: {
      "height": "300"
    }
  }, _vm._l((_vm.ticketsEnRecall), function(o, index) {
    return _c('ticket-summary-info', {
      key: index,
      staticClass: "animated fadeInUp faster",
      attrs: {
        "ticket": o,
        "is-chart": true
      }
    })
  }), 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c7b890f","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_card_chart_bar_tickets_en_recall.vue
// module id = 481
// module chunks = 1